import { Controller } from "@hotwired/stimulus"
import { formatElapsed } from "../lib/elapsed_label"

// Per-ticket SLA timer. Reads fired_at and threshold (minutes) and ticks
// every second. The label format and the late boundary (elapsed >=
// threshold) must match _ticket.html.erb's server-side computation exactly
// — that's what the card shows on first paint, before this controller's
// first tick runs, so a mismatch would flash the wrong state a second in.
// Styling toggles the same .ops-timer--late class the server applies
// rather than setting colour directly, so both sides draw from one rule.
export default class extends Controller {
  static values = { firedAt: String, threshold: Number }
  static targets = ["display"]

  connect() {
    if (!this.firedAtValue) return
    this.firedAt = new Date(this.firedAtValue).getTime()
    this.interval = setInterval(() => this.tick(), 1000)
    this.tick()
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
  }

  tick() {
    if (!this.hasDisplayTarget) return

    const elapsedSeconds = Math.floor((Date.now() - this.firedAt) / 1000)

    this.displayTarget.textContent = formatElapsed(elapsedSeconds)
    this.displayTarget.classList.toggle("ops-timer--late", Math.floor(elapsedSeconds / 60) >= this.thresholdValue)
  }
}
